import type { CalendarMessageType } from '@/types/calendar';

import { colors } from '@/styles/colors';
import { MILLIS_IN_MONTH } from '@/config/variables';

const CALENDAR_MESSAGE_TYPE_TO_COLORS: {
  [key in CalendarMessageType]: { color: string; bgColor: string };
} = {
  error: {
    color: colors.pink.c500,
    bgColor: colors.pink.c50,
  },
  warning: {
    color: colors.orange.c500,
    bgColor: colors.orange.c50,
  },
  success: {
    color: colors.green.c500,
    bgColor: colors.green.c50,
  },
};

const EVENT_HORIZON = 3 * MILLIS_IN_MONTH;

export { CALENDAR_MESSAGE_TYPE_TO_COLORS, EVENT_HORIZON };
